import { Link } from "react-router-dom";
import { useLang } from "@/context/LangContext";
import useSiteMeta from "@/hooks/useSiteMeta";
import { SITE } from "@/site";
import { BLOG_POSTS } from "@/data/blog";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import ScrollToTop from "@/components/ui/ScrollToTop";

const INDEX_META = {
  pl: {
    title: "Blog — poradniki i case studies | Przestrzeń Apps",
    description: "Artykuły o stronach www, aplikacjach webowych i SaaS. Praktyczne porady od zespołu Przestrzeń Apps.",
    canonical: `${SITE.url}/blog`,
  },
  en: {
    title: "Blog — guides and insights | Przestrzeń Apps",
    description: "Articles about websites, web apps and SaaS. Practical advice from the Przestrzeń Apps team.",
    canonical: `${SITE.url}/blog`,
  },
};

export default function BlogIndexPage() {
  const { lang } = useLang();
  useSiteMeta(lang, INDEX_META[lang]);

  return (
    <div className="bg-navy-deep text-white-warm min-h-screen">
      <Navbar />
      <main className="max-w-4xl mx-auto px-6 lg:px-20 pt-32 pb-24">
        <Link to="/" className="font-mono text-[10px] tracking-[0.28em] uppercase text-ice/70 hover:text-ice transition-colors">
          ← {lang === "pl" ? "Strona główna" : "Home"}
        </Link>

        <h1 className="font-display font-light text-white-warm mt-10" style={{ fontSize: "clamp(2.4rem, 5vw, 3.6rem)" }}>
          {lang === "pl" ? "Blog" : "Blog"}
        </h1>
        <p className="font-body text-base leading-[1.85] mt-4 max-w-xl" style={{ color: "rgba(242,232,216,0.55)" }}>
          {lang === "pl"
            ? "Praktyczne porady o stronach, aplikacjach i produktach cyfrowych."
            : "Practical advice on websites, apps and digital products."}
        </p>

        <div className="mt-14 space-y-6">
          {BLOG_POSTS.map((post) => (
            <article
              key={post.slug}
              className="p-8 rounded-lg border border-white/10 hover:border-ice/30 transition-colors"
              style={{ background: "rgba(255,255,255,0.02)" }}
            >
              <time className="font-mono text-[10px] tracking-[0.2em] uppercase" style={{ color: "rgba(242,232,216,0.35)" }}>
                {post.date}
              </time>
              <h2 className="font-display text-2xl font-light text-white-warm mt-3">
                <Link to={`/blog/${post.slug}`} className="hover:text-amber transition-colors">
                  {post.title[lang]}
                </Link>
              </h2>
              <p className="font-body text-sm leading-[1.8] mt-3" style={{ color: "rgba(242,232,216,0.55)" }}>
                {post.excerpt[lang]}
              </p>
              <Link
                to={`/blog/${post.slug}`}
                className="font-body text-[11px] tracking-[0.2em] uppercase inline-block mt-5 text-amber hover:text-ice transition-colors"
              >
                {lang === "pl" ? "Czytaj więcej →" : "Read more →"}
              </Link>
            </article>
          ))}
        </div>
      </main>
      <Footer />
      <ScrollToTop />
    </div>
  );
}